import React from "react"
import FontAwesome from "react-fontawesome"
import PropTypes from "prop-types"
import "./SubmitButton.scss"

const SubmitButton = props => {
  return (
    <div className="SubmitButton" onClick={props.onClick}>
      <FontAwesome name={"search"} />
    </div>
  )
}

SubmitButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default SubmitButton
